import NeoFeed from './neofeed';
export default NeoFeed;